import { Icon, isIconName } from '@advanza/ui'
import AutoRow from 'components/misc/AutoRow'
import { formatDistanceStrictWrap, utcToLocal } from 'date'
import UsersTag from 'interfaces/UsersTag'
import { CSSProperties } from 'react'

interface UsersTagStyle {
    icon?: string
    style?: CSSProperties
    [key: string]: UsersTagStyle | string | CSSProperties | undefined
}

const STYLE: {
    [key: string]: UsersTagStyle
} = {
    housing_status: {
        icon: '🏠',
        style: {
            backgroundColor: 'brown',
            color: 'white',
        },

        moving: {
            icon: '🚚',
        },
    },
    move_date: {
        icon: 'local_shipping',
        style: {
            backgroundColor: 'brown',
            color: 'white',
        },
    },
}

interface Props {
    usersTags?: UsersTag[]
}

const UsersTags = ({ usersTags = [] }: Props) => (
    <AutoRow>
        {usersTags.map((usersTag) => {
            const typeStyle = Object(STYLE[usersTag.type])
            const valueStyle = Object(STYLE[usersTag.type]?.[usersTag.value])
            const icon: string | undefined = valueStyle.icon || typeStyle.icon
            const style: CSSProperties | undefined = valueStyle.style || typeStyle.style

            return (
                <div className="rounded-lg px-2 py-1 text-center bg-tertiary-200" style={style}>
                    {icon && isIconName(icon) ? (
                        <Icon name={icon} fontSize={14} style={{ color: style?.color }} />
                    ) : (
                        icon
                    )}{' '}
                    {usersTag.type} {usersTag.value}{' '}
                    <small title={utcToLocal(usersTag.created)}>
                        {formatDistanceStrictWrap(usersTag.created, new Date())}
                    </small>
                </div>
            )
        })}
    </AutoRow>
)

export default UsersTags
